// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form-MultiBlock_multiBlock__z0HLl {
  background-color: var(--branded-light-gray);
  border-radius: 5px;
  padding: 15px 15px 30px;
  margin-bottom: 30px;
}

.Form-MultiBlock_multiBlock__z0HLl svg {
  font-size: 1.4rem;
}

.Form-MultiBlock_head__xm8Tc {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 5px;
  color: var(--branded-dark-gray);
}
.Form-MultiBlock_head__xm8Tc h3 {
  margin: 0;
}

.Form-MultiBlock_blocks__x6Zgc {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.Form-MultiBlock_block__YMk2w {
  background-color: white;
  border-radius: 5px;
  padding: 10px;
}

.Form-MultiBlock_actions__mBht4 {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dotted var(--branded-darker-gray);
  display: flex;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Form-MultiBlock.module.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;AACjC;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iDAAiD;EACjD,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".multiBlock {\n  background-color: var(--branded-light-gray);\n  border-radius: 5px;\n  padding: 15px 15px 30px;\n  margin-bottom: 30px;\n}\n\n.multiBlock svg {\n  font-size: 1.4rem;\n}\n\n.head {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  gap: 5px;\n  color: var(--branded-dark-gray);\n}\n.head h3 {\n  margin: 0;\n}\n\n.blocks {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.block {\n  background-color: white;\n  border-radius: 5px;\n  padding: 10px;\n}\n\n.actions {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px dotted var(--branded-darker-gray);\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiBlock": `Form-MultiBlock_multiBlock__z0HLl`,
	"head": `Form-MultiBlock_head__xm8Tc`,
	"blocks": `Form-MultiBlock_blocks__x6Zgc`,
	"block": `Form-MultiBlock_block__YMk2w`,
	"actions": `Form-MultiBlock_actions__mBht4`
};
export default ___CSS_LOADER_EXPORT___;
